import { ref } from 'vue';
import DashboardAPI from '@/api/dashboard';

export function useDashboardStats() {
  const stats = ref(null);

  const fetchStats = async () => {
    const response = await DashboardAPI.getStats();
    stats.value = response;
  };

  return {
    stats,
    fetchStats
  };
}
